import getEnv from '@/store/env'

export default {
  authorizationStatus: '',
  locale: getEnv('VUE_APP_I18N_LOCALE') || 'en',
  token: localStorage.getItem('token') || '',
  selectedSignatureProvider: {},
  signatureProviders: [],
  internalSignatureProviders: [],
  uploadedDocument: {},
  uploadedDocumentInfo: {},
  showPdfPrv: false
}
